import {SET_DESCRIPTION} from "../../constants";

const initialState = {
    description: []
}
export const DescriptionReducer = (state = initialState, action) => {
    switch (action.type){
        // case SET_DESCRIPTION:
        //     return {
        //         ...state,
        //         description: action.payload
        //     }
        default:
            return state;
    }
}